import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const WhatsAppButton = () => {
  const { t, language } = useLanguage();
  const whatsappNumber = '+5219511876202';
  
  const defaultMessage = language === 'en' 
    ? 'Hello Aerotucán, I have a question about...'
    : 'Hola Aerotucán, tengo una consulta sobre...';
  
  const message = encodeURIComponent(defaultMessage);
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center group"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        {t('whatsapp.buttonTooltip')}
      </span>
      
      {/* Indicador de "online" */}
      <span className="absolute top-0 right-0 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse"></span>
    </a>
  );
};

export default WhatsAppButton;
